// src/com/dc_temp_info/DcTempInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * DC_TEMP_INFO Apollo Graphql
 * DC 별 기준온도 설정
 * Project: NewTOP for cloud
 * 2024-12-05 17:14:36 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const DC_TEMP_INFO_LIST_PART = gql`
fragment DcTempInfoListPart on DcTempInfo {
    dcCd
    tempYn
    tempDeviation
    tempStartTime
    tempGapMinute
    tempChkCount
    tempSet1
    tempSet2St
    tempSet2En
    tempSet3St
    tempSet3En
    tempSet4St
    tempSet4En
    tempCalculSet1
    tempCalculSet2St
    tempCalculSet2En
    tempCalculSet3St
    tempCalculSet3En
    tempCalculSet4St
    tempCalculSet4En
    smsYn
    rcvrTelno1
    rcvrTelno2
    rcvrTelno3
    memo
    regDate
    regUser
    dcName
    regUserName
}
`;


export const LIST_DC_TEMP_INFO = gql`
${DC_TEMP_INFO_LIST_PART}
query ListDcTempInfo {
    dcTempInfoList {
        ...DcTempInfoListPart
    }
}
`;

export const GET_DC_TEMP_INFO = gql`
${DC_TEMP_INFO_LIST_PART}
query GetDcTempInfo($dcCd:String!) {
    dcTempInfoItem(dcCd:$dcCd) {
        ...DcTempInfoListPart
    }
}
`;


export const EDIT_DC_TEMP_INFO = gql`
mutation EditDcTempInfo($dcTempInfo:InputDcTempInfoEdit!) {
	dcTempInfoEdit(dcTempInfo: $dcTempInfo) {
		ok
		message
	}
}
`;

export const REMOVE_DC_TEMP_INFO = gql`
mutation RemoveDcTempInfo($dcTempInfo:InputDcTempInfoRemove!) {
	dcTempInfoRemove(dcTempInfo: $dcTempInfo) {
		ok
		message
	}
}
`;
